import { render } from "./IconCogOutlined.vue?vue&type=template&id=0cc7301c"
import script from "./IconCogOutlined.vue?vue&type=script&lang=js"
export * from "./IconCogOutlined.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__